import React, {useEffect, useState} from 'react';
import {format} from 'date-fns';
import axios from 'axios';
import {
    Backdrop,
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Divider,
    Grid,
    makeStyles,
    Modal,
    Paper,
    Tab,
    Tabs,
    Typography,
} from "@material-ui/core";
import useStyles from '../styles/styles';
import {useQuery} from "@apollo/react-hooks";
import {Alert} from '@material-ui/lab';
import {gql} from "apollo-boost";
import LeadsTestingToolFields from '../utils/LeadsTestingToolFields';
import useFormInputs from "../hooks/useFormInputs";
import RenderInput from '../components/TrafficSource/RenderInput';
import ParseResponse from '../utils/ParseResponse';

const useBoxStyles = makeStyles({
    root: {
        height: '400px',
        overflowY: 'scroll'
    },
    divider: {
        margin: '20px 0'
    }
});
/**
 * @todo - validation
 */
const LeadsTestingTool = () => {
    const classes = useStyles();
    const boxClasses = useBoxStyles();
    const [manualLoad, setManualLoad] = useState(false);
    const [modalData, setModalData] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const onSubmit = () => {
        let error = false
        setIsError(error);
        let nonRequiredFields = [];
        LeadsTestingToolFields.forEach((section) => {
            section.arr.forEach((item) => {
                if (!item.required) {
                    nonRequiredFields.push(item.key);
                }
            });
        });
        Object.keys(inputs).forEach(key => {
            if (nonRequiredFields.includes(key)) {
                return;
            }
            const value = inputs[key];

            if (value === '') {
                console.error(`${key} is a required field.`);
                error = true;
            }
        });

        if (!error) {
            setManualLoad(true);
            Object.keys(inputs).forEach(key => inputs[key] === '' && delete inputs[key]);
            submitForm(inputs);
        } else {
            setIsError(true)
        }
    };
    const {clearAllInputs, inputs, handleFilterChange, handleInputChange, handleSwitchChange, handleSubmit, setInputs} = useFormInputs(onSubmit);

    const {loading, error, data, refetch, networkStatus} = useQuery(gql`
        query LeadsTestingTool {
            fakeApiRequest {
                pingTree
                sourceKey
                referringSiteUrl
                everflowTransactionId
                sourceSubCode1
                sourceSubCode2
                sourceSubCode3
                sourceLeadId
                minimumPrice
                minimumLoanAmount
                maximumLoanAmount
                isTestApp
                dateCreatedEffective
                firstName
                middleName
                lastName
                primaryEmail
                homePhone
                mobilePhone
                bestCallTime
                dateOfBirth
                ssn
                streetAddress
                streetAddress2
                city
                state
                zip
                residenceType
                residenceLengthMonths
                military
                stateIdNumber
                stateIdIssued
                creditScore
                userAgent
                clientIpAddress
                bankName
                bankRouting
                bankAccount
                bankAccountType
                monthsAtBank
                employmentType
                employerName
                employerLengthMonths
                workPhone
                workExt
                payFrequency
                monthlyIncome
                payType
                nextPayDate
                secondPayDate
            }
            allTrafficSource {
                nodes {
                    id
                    name
                }
            }
            allPingTree {
                nodes {
                    id
                    name
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    useEffect(() => {
        if (data && Object.keys(data).length) {
            clearAllInputs();
            LeadsTestingToolFields.forEach(section => {
                section.arr.forEach(item => {
                    const {fakeKey, key, type, dateFormat, val} = item;
                    if (inputs[key] === undefined) {
                        const dataKey = data.fakeApiRequest[fakeKey];
                        let value = dataKey === '' || dataKey === null ? '' : dataKey;
                        if (type === 'date' && dateFormat) {
                            value = format(new Date(value), dateFormat);
                        }

                        if (value !== val && type === 'switch') {
                            value = val;
                        }

                        setInputs(inputs => ({
                            ...inputs,
                            [key]: value
                        }));
                    }
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const openModal = data => {
        const respData = JSON.parse(data);
        setModalData({
            response: data,
            request: inputs,
            leadId: respData.request_id,
            status: respData.status
        });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setModalData({});
        setIsModalOpen(false);
    };

    const handleTabClick = (e, val) => {
        setSelectedTab(val);
    };

    const submitForm = (finalInputs) => {
        const isLocalHost = window.location.host.includes('localhost');
        const url = isLocalHost ? 'http://localhost:9090/loan/' : '/loan/';
        axios.post(url, JSON.stringify(finalInputs), {
            headers: {
                'Authorization': 'Basic dGVzdDp0ZXN0',
                'Content-Type': 'application/json',
            }
        })
            .then(function (response) {
                openModal(JSON.stringify(response.data));
                setManualLoad(false);
            })
            .catch(function (error) {
                openModal(JSON.stringify(error));
                setManualLoad(false);
            });
    };

    if (loading || manualLoad || networkStatus === 4) {
        return (
            <Backdrop className={classes.backdrop} open={loading || manualLoad || networkStatus === 4}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    if (error) {
        return (
            <>
                <Typography variant="h2">
                    Leads Testing Tool
                </Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }
    return (
        <>
            <Typography variant="h2">
                Leads Testing Tool
            </Typography>
            <Paper className={classes.paper}>
                <Container maxWidth={false}>
                    <form id="leads-testing-tool" onSubmit={handleSubmit}>
                        {isError ? (
                            <Alert severity="error">Please add values to the highlighed fields!</Alert>
                        ) : false}
                        <Grid container spacing={4}>
                            {LeadsTestingToolFields.map((section) => {
                                const {title, arr} = section;
                                return (
                                    <Grid item xs={12} key={title}>
                                        <Box className={classes.filterBox} style={{margin: '1rem 0 0'}}>
                                            <Chip
                                                label={title}
                                                className={classes.filterSectionLabels}
                                            />
                                            <Grid container spacing={4} direction="row" justify="flex-start"
                                                  alignItems="center">
                                                {arr.map(item => {
                                                    const {key, label, val} = item;
                                                    return (
                                                        <Grid key={key} item xs={3}>
                                                            <Typography variant="body1">
                                                                <strong>{label}</strong>
                                                            </Typography>
                                                            <RenderInput
                                                                item={item}
                                                                value={inputs[key] || ''}
                                                                data={Array.isArray(val) ? val : data}
                                                                handleFilterChange={handleFilterChange}
                                                                handleInputChange={handleInputChange}
                                                                handleSwitchChange={handleSwitchChange}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                );
                            })}
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        refetch();
                                    }}
                                    style={{marginRight: '1rem'}}>
                                    Re-Populate Form
                                </Button>
                                <Button type="submit" variant="contained" color="primary">
                                    Submit Lead
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Paper>
            <Modal
                open={isModalOpen}
                onClose={closeModal}
            >
                <Paper className={classes.modal}>
                    <Tabs
                        aria-label="raw data tabs"
                        value={selectedTab}
                        onChange={handleTabClick}
                        indicatorColor="secondary"
                        centered
                    >
                        <Tab
                            label="Response Raw Tab"
                            id="raw-data-0"
                        />
                        <Tab
                            label="Request Raw Tab"
                            id="request-data-0"
                        />
                    </Tabs>
                    <Paper className={classes.paper}>
                        <Box
                            component="div"
                            role="tabpanel"
                            hidden={selectedTab !== 0}
                            className={boxClasses.root}
                        >
                            <Box display="flex" alignItems="center" flexDirection="row">
                                <Button variant="contained" color="primary" onClick={() => {
                                    window.open(`/info/leads/${modalData.leadId}`);
                                }}>
                                    View Lead
                                </Button>
                                <Alert style={{marginLeft: '10px'}}
                                       severity={`${modalData.status === 'ACCEPTED' ? 'success' : 'error'}`}>{modalData.status}</Alert>
                            </Box>
                            <Divider className={boxClasses.divider}/>
                            {modalData.response ? (
                                <ParseResponse data={modalData.response}/>
                            ) : null}
                        </Box>
                        <Box
                            component="div"
                            role="tabpanel"
                            hidden={selectedTab !== 1}
                            className={boxClasses.root}
                        >
                            {modalData.request ? (
                                <ParseResponse data={JSON.stringify(modalData.request)}/>
                            ) : null}
                        </Box>
                    </Paper>
                </Paper>
            </Modal>
        </>
    );
};

export default LeadsTestingTool;